import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchUnresolvedIncidentsSuccess } from "domains/incidents/actions";
import type { APIIncident } from "domains/incidents/types";

export function* fetchUnresolvedIncidentsSaga() {
  try {
    const payload: APIIncident[] = yield apiFetch("incident/unresolved");
    yield put(fetchUnresolvedIncidentsSuccess(payload));
  } catch (error) {
    logger.error("[fetchUnresolvedIncidentsSaga] Failed to fetch unresolved incidents", error);
  }
}
